import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import { NoAccessWarning } from '../../util/i18n';
export var NoAccessTooltip = function NoAccessTooltip(_ref) {
  var name = _ref.name,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(NoAccessWarning, {
    values: {
      name: name
    }
  }, function (text) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: text,
      position: "right"
    }, children);
  });
};